export const bootcamps = [
    {
        iconName: 'fa-2x fab fa-js-square',
        title: 'Headless / JSS',
        text: 'Learn to use Sitecore JavaScript Services to deliver headless experiences',
        link: 'https://altola.co/bootcamps/jss'
    },
    {
        iconName: 'fa-2x fas fa-exchange-alt',
        title: 'xConnect',
        text: 'Understand how xConnect can help you connect data to and from Sitecore',
        link: 'https://altola.co/bootcamps/xconnect'
    },
    {
        iconName: 'fa-2x far fa-user-circle',
        title: 'Personalization',
        text: 'Best practices for real time data collection and personalization architecture',
        link: 'https://altola.co/bootcamps/personalization'
    },
    {
        iconName: 'fa-2x fas fa-keyboard',
        title: 'Sitecore as a platform',
        text: 'Deep dive into different ways you can extend Sitecore and build customized solutions'
    },
    {
        iconName: 'fa-2x fas fa-user-check',
        title: 'Context Marketing',
        text: 'Get into the nuts and bolts of Context Marketing best practices and program approach'
    },
    {
        iconName: 'fa-2x fas fa-puzzle-piece',
        title: 'Ad hoc',
        text: 'Get in touch for any specific needs, related to customer projects'
    }
];


// WEBPACK FOOTER //
// ./src/content/collections/partnerbootcamps.js